#### Profile Apply

When a candidate applies on SEEK through a supported channel,
they consent to share a snapshot of their SEEK Profile with the hirer.

We’ve extended [Application Export] with more structured information on the [`CandidateProfile`] object:

- `employment` includes multiple roles from the candidate’s employment history,
  along with a description of their achievements and responsibilities in each role.
- `education` describes educational programs that the candidate has completed and is currently pursuing.
- `qualifications` lists the self-asserted skills of the candidate.

```graphql
query ($id: String!) {
  candidateProfile(id: $id) {
    employment {
      positionHistories {
        descriptions
      }
    }
    education {
      educationDegrees {
        name
      }
    }
    qualifications {
      competencyName
    }
  }
}
```

```json
{
  "id": "seekAnzPublicTest:candidateProfile:apply:5G5NaFDmy7UigvGy6aT6VT"
}
```

See our documentation on [exporting candidate profiles] for more information.

[`candidateprofile`]: /schema/named-type/CandidateProfile
[application export]: /use-cases/application-export
[exporting candidate profiles]: /use-cases/application-export/candidate-profiles
